export default __webpack_public_path__ + "static/media/hero_img_1.fbf2bc85.svg";